import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '../ui/Button';
import { prescriptionSteps } from '../../data/prescriptionSteps';
export function PrescriptionCollection() {
  const cta = <Button href="tel:+2676540244" variant="primary" icon={<Phone className="w-5 h-5" data-id="element-174" data-mp="3tgvhi6dmjrsy" />} data-id="element-173" data-mp="2a15xelan4xm">
      Speak to Our Reception Team
    </Button>;
  return <section className="py-24 bg-white overflow-hidden" aria-labelledby="prescription-collection-heading" data-id="element-175" data-mp="3ohr9hj2fs047">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176" data-mp="3jiem8x7nkr13">
        {/* Photo + intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-177" data-mp="3fgkrf5k52h8u">
          <div className="rounded-2xl overflow-hidden shadow-soft-lg" data-id="element-178" data-mp="3ai9hkutug6qm">
            <img src="https://cdn.magicpatterns.com/uploads/dJAXajB4UhJpmXArfBLT6j/image.png" alt="The Maisha Medical Center vehicle parked outside the clinic" className="w-full h-auto block" data-id="element-179" data-mp="3akce7xpi4y4b" />
          </div>

          <div data-id="element-180" data-mp="kmh8om1jwb1m">
            <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-181" data-mp="klxoszscbcky">
              Patient Convenience
            </span>
            <h2 id="prescription-collection-heading" className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-brand-navy mb-6 leading-tight" data-id="element-182" data-mp="bnc9ddi60doe">
              We’ve Made Prescription Collection Easier
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed mb-8" data-id="element-183" data-mp="18ctlobbnkxz2">
              After your consultation, our healthcare professionals provide your
              prescription based on your medical needs. While Maisha Medical
              Center does not currently have an on-site pharmacy, we make the
              process more convenient by using our Maisha vehicle to collect
              your prescribed medication from the nearest local pharmacy.
            </p>
            <p className="border-l-4 border-brand-gold pl-5 text-xl font-heading font-semibold text-brand-navy mb-10" data-id="element-184" data-mp="1s2x0q581365a">
              Your consultation. Your prescription. Added convenience.
            </p>
            <div className="hidden lg:flex" data-id="element-185" data-mp="1wvn2rld5inq2">{cta}</div>
          </div>
        </div>

        {/* How it works */}
        <div className="mt-20" data-id="element-186" data-mp="1mzjzudah6l22">
          <h3 className="text-2xl font-heading font-bold text-brand-navy mb-10" data-id="element-187" data-mp="1n0bikniz4oax">
            How It Works
          </h3>
          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10" data-id="element-188" data-mp="1iyq818twwm3w">
            {prescriptionSteps.map(step => <li key={step.number} className="border-t-2 border-slate-100 pt-6" data-id="element-189" data-mp="1985373nnalcj">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-navy text-white font-heading font-bold mb-5" data-id="element-190" data-mp="196136wsva6hj">
                  {step.number}
                </span>
                <h4 className="font-heading font-bold text-lg text-brand-navy mb-2" data-id="element-191" data-mp="zbsbgbbnuhkf">
                  {step.title}
                </h4>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-192" data-mp="36w90phrszjcx">
                  {step.desc}
                </p>
              </li>)}
          </ol>
          <div className="mt-10 lg:hidden" data-id="element-193" data-mp="3az5mfhcn3vl3">{cta}</div>
        </div>

        {/* Added-value callout */}
        <div className="mt-16 rounded-3xl bg-brand-navy px-8 py-10 md:px-14 md:py-12 flex flex-col md:flex-row md:items-center gap-6 md:gap-10" data-id="element-194" data-mp="3kvgyq7c8clfj">
          <div className="w-1.5 h-12 md:h-16 bg-brand-gold rounded-full shrink-0 hidden md:block" data-id="element-195" data-mp="2n8rtzpq57upz" />
          <p className="text-white text-xl md:text-2xl font-heading font-bold leading-snug" data-id="element-196" data-mp="2s7l5jclvdbni">
            We may not have an on-site pharmacy yet — but we’re still making
            medication collection easier for our patients.
          </p>
        </div>
      </div>
    </section>;
}